import { dataElementSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconElementSolid = /*#__PURE__*/createIcon(dataElementSolid)
export default IconElementSolid
